import { Icon } from "@/components/Icon";
import styles from "./index.module.scss";
type Key = { value: string; text: number | string | React.ReactNode };
const keys: Key[][] = [
  [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
  ],
  [
    { value: "4", text: "4" },
    { value: "5", text: "5" },
    { value: "6", text: "6" },
  ],
  [
    { value: "7", text: "7" },
    { value: "8", text: "8" },
    { value: "9", text: "9" },
  ],
  [
    { value: "", text: "" },
    { value: "0", text: "0" },
    { value: "删除", text: <Icon name={"delete"} size={"20px"} /> },
  ],
];

type Props = {
  onInput?: (val: string) => void;
  onDelete?: () => void;
};

export const PwsInput = ({ onInput, onDelete }: Props) => {
  const onItemClick = (key: Key) => {
    if (!key.value) {
      return "";
    }
    if (key.value === "删除") {
      return onDelete && onDelete();
    }
    return onInput && onInput(key.value);
  };
  return (
    <div className={styles.input_content}>
      <div className={styles.input_pane}>
        {keys.map((keyRow, i: number) => {
          return (
            <div key={i} className={styles.input_pane_row}>
              {keyRow.map((key, j: number) => {
                return (
                  <div
                    key={`${i}-${j}`}
                    onClick={() => onItemClick(key)}
                    className={`${styles.input_pane_col} ${
                      key.value !== "" && key.value !== "删除" ? styles.num : ""
                    }`}
                  >
                    {key.text}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
